module.exports = __webpack_public_path__ + "static/Banner carrousel home Enero-07-936f5e52b01332d60cf56674d4e51d82.jpg";